import { Types } from '@store/types';

const initialState = [];

const CommercialReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_COMMERCIAL_INVOICE_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default CommercialReducer;
